import { Injectable } from '@angular/core';
import { Api, User } from '@providers/index'

@Injectable()
export class Schedule {
  list: any;

  constructor(public api:Api, public user:User) { 

  }

  get(params?: any) {
    return this.api.get('index.php/project/schedule', params);
  }

  getActivity(params?: any) {
    return this.api.get('index.php/project/activity', params);
  }


  post(params?: any) {
    if(params.id==''){
      params.created_by = this.user.data.employee_id;
    }else{
      params.updated_by = this.user.data.employee_id;
    }
    return this.api.post('index.php/project/schedule', params);
  }

  getScheduleImage(params?:any){
    return this.api.get('index.php/project/schedule/scheduleImages', params);
  }

  getActivityType(params?:any){
    return this.api.get('index.php/project/schedule/activityType', params);
  }
  
  delete(params?: any) {
    return this.api.post('index.php/project/schedule/delete', params);
  }


}


// WEBPACK FOOTER //
// ./src/providers/project_providers/schedule/schedule.ts